import { render, staticRenderFns } from "./LiveCameraCapture.vue?vue&type=template&id=a4a53a1e&scoped=true"
import script from "./LiveCameraCapture.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiveCameraCapture.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LiveCameraCapture.vue?vue&type=style&index=0&id=a4a53a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a53a1e",
  null
  
)

export default component.exports